import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {TitanButtonComponent} from '../../../user-interface/titan-button/titan-button.component';

import {EmbeddedLoaderComponent} from '../../embedded-components/embedded-loader.component';

@Component({
  selector: 'app-loader-modal',
  standalone: true,
  imports: [
    MatIconModule,
    TitanButtonComponent,
    EmbeddedLoaderComponent
  ],
  templateUrl: './loader-modal.component.html'
})

export class LoaderModalComponent implements OnInit {
  title = '';
  textContent = '';
  image = '';
  buttonText = 'Close';
  countdown?: number;
  countdownText = 'Estimated time remaining: ';

  constructor(
    public dialogRef: MatDialogRef<LoaderModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {title: string, content: string, image?: string, buttonText?: string, countdown?: number, countdownText?: string},
  ) { }

  ngOnInit(): void {
    this.title = this.data.title;
    this.textContent = this.data.content;
    this.image = this.data.image || '';
    if (this.data.buttonText) this.buttonText = this.data.buttonText;
    if (this.data.countdown) this.countdown = this.data.countdown;
    if (this.data.countdownText) this.countdownText = this.data.countdownText;
  }
}
